import { ResourcesProps, SettingProps } from "../resources/defaultState"

export enum ClosedCaptionsViews {
  NO_CAPTIONS = 'noCaptions',
  SELECT_FILE = 'selectFile',
  LIST = 'lists',
  DELETE = 'delete'
}

export interface ClosedCaptionsStatus {
  isLoading: boolean
  isSubmitting: boolean
  isUploading: boolean
  isProcessing: boolean
  isDeleting: boolean
  hasError: boolean
  submitSuccess: boolean
  transcriptionsEnabled: boolean
}

export interface ClosedCaptionsInterface {
  view: ClosedCaptionsViews
  status: ClosedCaptionsStatus
  activeResource?: ResourcesProps
  setting?: SettingProps
  uploader?: any
  interval?: string[]
}

export interface CaptionFileProps {
  href?: string
  hosted: string
  mimeType?: string
  size?: number
  percent?: any
  name?: string
}

export interface ClosedCaptionsDataProps {
  id: string
  title: string
  description: string
  file?: CaptionFileProps
  isCancelled?: boolean
}

const defaultState: ClosedCaptionsInterface  = {
  view: ClosedCaptionsViews.NO_CAPTIONS, // TODO: TO BE CHANGED BASED ON IF CAPTIONS files already exist
  status: {
    isLoading: false,
    isSubmitting: false,
    isUploading: false,
    isProcessing: false,
    isDeleting: false,
    hasError: false,
    submitSuccess: false,
    transcriptionsEnabled: false
  }
}

export default defaultState